import { DESTINATION_TYPE } from '@/app/search/types.ts';
import { getTotalNumChildren, getTotalNumInfants } from '@/utils/peopleUtils.ts';

export type RoomsDetailsParams = { adults: string; ages: string };

export type RoomsDetails = string;

export type RoomsContentParams = { adults: string; ages?: string };

export type RoomContent = {
  adults: number;
  children: number;
  infants: number;
};

export type RoomsContent = RoomContent[];

export type StayDateParams = {
  dateFrom?: string;
  dateTo?: string;
};

export type LengthOfStay = {
  min: number | null;
  max: number | null;
};

export type DateRange = {
  from: string | null;
  to: string | null;
};

export type StayDates = {
  lengthOfStay: LengthOfStay;
  departureDate: DateRange;
  returnDate: DateRange;
};

export enum STARTRACK_DESTINATION_TYPE {
  AIRPORT = 'AIRPORT',
  TAG = 'TAG',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  TRAIN_STATION = 'TRAIN_STATION',
}

export const getDestinationsType = (destination: string, destinationType?: DESTINATION_TYPE): string => {
  if (destinationType === DESTINATION_TYPE.AIRPORT) return STARTRACK_DESTINATION_TYPE.AIRPORT;
  if (destinationType === DESTINATION_TYPE.TAG) return STARTRACK_DESTINATION_TYPE.TAG;
  if (destinationType === DESTINATION_TYPE.CITY) return STARTRACK_DESTINATION_TYPE.CITY;
  if (destinationType === DESTINATION_TYPE.COUNTRY) return STARTRACK_DESTINATION_TYPE.COUNTRY;
  if (destinationType === DESTINATION_TYPE.TRAIN_STATION) return STARTRACK_DESTINATION_TYPE.TRAIN_STATION;
  if (destinationType === DESTINATION_TYPE.GEO) return destination.split('-')[0];
  return 'INSPIRATIONAL_TAG';
};

export const getRoomsDetails = ({ adults, ages }: RoomsDetailsParams): RoomsDetails => {
  const rooms: string[] = [];
  const agesArray = ages ? ages.split(';') : [];
  adults.split(';').forEach((x, i) => {
    const room = [];
    room.push(`${x}`);

    if (agesArray[i] && agesArray[i].length > 0) {
      room.push(`,${agesArray[i].split(',').length}-`);
      const agesSubArray: string[] = [];
      agesArray[i].split(',').forEach((y) => {
        agesSubArray.push(`${y}`);
      });
      room.push(agesSubArray.join(','));
    } else {
      room.push(',0');
    }
    rooms.push(room.join(''));
  });
  return rooms.join('#');
};

export const createRoomsContent = ({ adults, ages }: RoomsContentParams): RoomsContent => {
  if (!adults) return [];
  const agesPerRoom = ages ? ages.split(';') : [];

  return adults.split(';').map((adultsNum, index) => {
    const children = agesPerRoom.length >= index + 1 ? getTotalNumChildren(agesPerRoom[index]) : 0;
    const infants = agesPerRoom.length >= index + 1 ? getTotalNumInfants(agesPerRoom[index]) : 0;
    return { adults: parseInt(adultsNum, 10), children, infants };
  });
};

export const createStayDates = ({ dateFrom, dateTo }: StayDateParams): StayDates => {
  const isDepartureMonth = dateFrom ? dateFrom.indexOf(',') !== -1 : false;
  const isReturnTime = dateTo ? dateTo.indexOf('T') !== -1 : false;

  return {
    lengthOfStay: {
      min: isReturnTime && dateTo ? parseInt(dateTo.split(',')[1], 10) : null,
      max: isReturnTime && dateTo ? parseInt(dateTo.split(',')[2], 10) : null,
    },
    departureDate: {
      from: isDepartureMonth && dateFrom ? dateFrom.split(',')[0] : dateFrom || null,
      to: isDepartureMonth && dateFrom ? dateFrom.split(',')[1] : dateFrom || null,
    },
    returnDate: {
      from: !isReturnTime ? dateTo || null : null,
      to: !isReturnTime ? dateTo || null : null,
    },
  };
};
